import BaseComponent from "@js/components/base_component.jsx";
import { Modal, ModalHeader, ModalBody, ModalFooter, ModalButton } from "@js/components/eui/modal/index.js";

class EuiHelpIcon extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            show_modal: false,
        };
    }

    render() {
        // Help is always offered as a "?" question-mark icon. When a label is
        // provided (typically a field label passed as children), render it plain
        // and put the clickable "?" icon after it.
        const hasLabel = this.props.children !== undefined && this.props.children !== null;

        return (
            <React.Fragment>
                { hasLabel && this.props.children }
                <a onClick={ this._onClickIcon } className="eui-help-icon">&nbsp;<FaIcon name="question-circle"/></a>
                {
                    this.state.show_modal && this._renderModal()
                }
            </React.Fragment>
        );
    }

    _renderModal() {
        return (
            <Modal>
                {
                    this.props.title && (
                        <ModalHeader onCancel={ this._hideModal }>
                            { this.props.title }
                        </ModalHeader>
                    )
                }
                <ModalBody>
                    <div dangerouslySetInnerHTML={{ __html: this.props.textRawHtml }}/>
                </ModalBody>
                <ModalFooter>
                <ModalButton onClick={ this._hideModal }>{ t("buttons.close") }</ModalButton>
                </ModalFooter>
            </Modal>
        );
    }

    componentWillUnmount() {
        this._stopListeningForEscape();
    }

    _onClickIcon(e) {
        e.preventDefault();
        this._showModal();
    }

    _onKeyDown(e) {
        if ( e.key === "Escape" ) this._hideModal();
    }

    _showModal() {
        document.addEventListener("keydown", this._onKeyDown);
        this.setState({ show_modal: true });
    }

    _hideModal() {
        this._stopListeningForEscape();
        this.setState({ show_modal: false });
    }

    _stopListeningForEscape() {
        document.removeEventListener("keydown", this._onKeyDown);
    }

}

export default EuiHelpIcon;
